import * as Fiz from "../util/Fiz.ts";
import { PremiumRightBean, ServerBeanPrototype, type IMedia } from "./fizapilib.auto.ts";

/**
 * thumb() is defined on ServerBeanPrototype, so on every bean, and reads defensively whichever
 * picture/name field the concrete bean happens to carry.
 */
type Thumbable = ServerBeanPrototype & {
  firstName?: string;
  firstname?: string;
  accountFirstname?: string;
  color?: string;
  coverUri?: string;
  picture?: string;
  pictureUrl?: string;
  pictureDefault?: boolean;
  medias?: IMedia[];
  /** im participant */
  accountMedias?: IMedia[];
}

// Augmentation of the generated beans with the methods added dynamically below
declare module "./fizapilib.auto.ts" {
  interface ServerBeanPrototype {
    thumbDefault(): string;
    thumbNoDefault(): string | undefined;
    thumb(size?: number): string | undefined;
    lastMediaImage(): IMedia | null;
  }
  interface PremiumRightBean {
    isPremium(): boolean;
  }
}

Object.assign(PremiumRightBean.prototype,{
  isPremium(this: PremiumRightBean): boolean {
    return this.fWPremiumPopup === true;
  }

});

Object.assign(ServerBeanPrototype.prototype,{
  thumbDefault(this: Thumbable): string {
    return Fiz.getDefaultUrl(this.firstName||this.firstname||this.accountFirstname||'',this.color||"#c9c9c9");
  },
  thumbNoDefault(this: Thumbable): string | undefined {
    if(this.pictureDefault) return undefined;
    return this.thumb();
  },
  thumb(this: Thumbable, size=120): string | undefined {
    if(this.coverUri){
      return Fiz.getPictureUrl(this.coverUri,size,size);
    }else if(this.pictureDefault){
      return this.thumbDefault()
    }else if(this.picture){
      return Fiz.getPictureUrl(this.picture,size,size);
    }else if(this.pictureUrl){
      return Fiz.getPictureUrl(this.pictureUrl,size,size);
    }else if(this.medias && this.medias.length){
      return Fiz.getPictureUrl(this.medias[0].pictureUrl,size,size);
    }else if(this.accountMedias && this.accountMedias.length){
      //im participant
      return Fiz.getPictureUrl(this.accountMedias[0].pictureUrl,size,size);
    }else{
      return undefined;
    }
  },
  lastMediaImage(this: Thumbable): IMedia | null {
    return this.medias?.reduce((prev,next)=>next.isImage()?next:prev,null)
  }
});
